const QUERY_KEYS = {
  // AUTH
  LOGIN_QUERY_KEY: "LOGIN_QUERY_KEY",
  FORGOT_PASSWORD_QUERY_KEY: "FORGOT_PASSWORD_QUERY_KEY",
  VERIFY_OTP_QUERY_KEY: "VERIFY_OTP_QUERY_KEY",
  RESEND_OTP_QUERY_KEY: "RESEND_OTP_QUERY_KEY",
  RESET_PASSWORD_QUERY_KEY: "RESET_PASSWORD_QUERY_KEY",
  CHANGE_PASSWORD_QUERY_KEY: "CHANGE_PASSWORD_QUERY_KEY",
  GET_PROFILE_QUERY_KEY: "GET_PROFILE_QUERY_KEY",
  EDIT_PROFILE_QUERY_KEY: "EDIT_PROFILE_QUERY_KEY",

  //  GROWER
  ADD_GROWER_QUERY_KEY: "ADD_GROWER_QUERY_KEY",
  LIST_GROWER_QUERY_KEY: "LIST_GROWER_QUERY_KEY",
  GROWER_DETAIL_QUERY_KEY: "GROWER_DETAIL_QUERY_KEY",
  EDIT_GROWER_QUERY_KEY: "EDIT_GROWER_QUERY_KEY",
  DELETE_GROWER_QUERY_KEY: "DELETE_GROWER_QUERY_KEY",

  // CROP
  CROP_LIST_QUERY_KEY: "CROP_LIST_QUERY_KEY",
  // FIELD
  ADD_FIELD_QUERY_KEY: "ADD_FIELD_QUERY_KEY",
  LIST_FIELD_QUERY_KEY: "ADD_FIELD_QUERY_KEY",
  DETAIL_FIELD_QUERY_KEY: "DETAIL_FIELD_QUERY_KEY",
  EDIT_FIELD_QUERY_KEY: "EDIT_FIELD_QUERY_KEY",
  DELETE_FIELD_QUERY_KEY: "DELETE_FIELD_QUERY_KEY",
  GROWER_LIST_FIELD_QUERY_KEY: "GROWER_LIST_FIELD_QUERY_KEY",
  ACTIVE_FIELD_LIST_QUERY_KEY: "ACTIVE_FIELD_LIST_QUERY_KEY",

  //  SCOUTING

  ADD_SCOUTING_QUERY_KEY: "ADD_SCOUTING_QUERY_KEY",
  SCOUTING_LIST_QUERY_KEY: "SCOUTING_LIST_QUERY_KEY",
  SCOUTING_DETAIL_QUERY_KEY: "SCOUTING_DETAIL_QUERY_KEY",
  SCOUTING_DELETE_QUERY_KEY: "SCOUTING_DELETE_QUERY_KEY",
  SCOUTING_EDIT_QUERY_KEY: "SCOUTING_EDIT_QUERY_KEY",

  // PRODUCT
  ADD_PRODUCT_QUERY_KEY: "ADD_PRODUCT_QUERY_KEY",
  // CROP PLAN
  ADD_CROP_PLAN_QUERY_KEY: "ADD_CROP_PLAN_QUERY_KEY",
  CROP_PLAN_LIST_QUERY_KEY: "CROP_PLAN_LIST_QUERY_KEY",
  EDIT_CROP_PLAN_QUERY_KEY: "EDIT_CROP_PLAN_QUERY_KEY",
  CROP_PLAN_DETAIL_QUERY_KEY: "CROP_PLAN_DETAIL_QUERY_KEY",
  CROP_PLAN_DELETE_QUERY_KEY: "CROP_PLAN_DELETE_QUERY_KEY",

  // NEW WORK
  ADD_SEASON_PLAN_QUERY_KEY: "ADD_SEASON_PLAN_QUERY_KEY",
  EDIT_SEASON_PLAN_QUERY_KEY: "EDIT_SEASON_PLAN_QUERY_KEY",
  SEASON_PLAN_LIST_QUERY_KEY: "SEASON_PLAN_LIST_QUERY_KEY",
  DELETE_SEASON_PLAN_LIST_QUERY_KEY: "DELETE_SEASON_PLAN_LIST_QUERY_KEY",
  // CONTENT
  GET_CONTENT_QUERY_KEY: "GET_CONTENT_QUERY_KEY",
  SEASON_YEAR_LIST_QUERY_KEY: "SEASON_YEAR_LIST_QUERY_KEY",
  ADD_CROP_LIST_QUERY_KEY: "ADD_CROP_LIST_QUERY_KEY",

  // DASHBOARD
  DASHBOARD_QUERY_KEY: "DASHBOARD_QUERY_KEY",
};

export default QUERY_KEYS;
